import confetti from 'canvas-confetti'
import { useReducedMotion } from 'framer-motion'
import { RefObject, useCallback } from 'react'

interface Origin {
  x?: number
  y?: number
}

interface ConfettiOptions {
  ref?: RefObject<any> // Set as origin zero point
  particleCount?: number
  angle?: number
  spread?: number
  startVelocity?: number
  decay?: number
  gravity?: number
  drift?: number
  ticks?: number
  origin?: Origin
  colors?: string[]
  shapes?: string[]
  scalar?: number
  zIndex?: number
}

type PropsOut = (options?: ConfettiOptions) => Promise<any>

// Simple wrapper around the confetti what implements
// useReducedMotion hook from framer-motion library.
export const useConfetti = (options: ConfettiOptions): PropsOut => {
  const disableForReducedMotion = useReducedMotion()
  const defaults = { ...options, disableForReducedMotion }

  const getRefCoordinates = useCallback((ref: RefObject<any>) => {
    if (ref) {
      const { top, left, width, height } = ref.current.getBoundingClientRect()
      return {
        x: (left + width / 2) / window.innerWidth,
        y: (top - height / 2) / window.innerHeight
      }
    } else {
      return { x: 0, y: 0 }
    }
  }, [])

  return (options: ConfettiOptions) => {
    let origin = {}

    if (defaults?.ref) {
      origin = getRefCoordinates(defaults.ref)
      delete defaults['ref']
    }

    if (options?.ref) {
      origin = getRefCoordinates(options.ref)
      delete options['ref']
    }

    return confetti({ origin, ...defaults, ...options })
  }
}
